<script setup>
/**
 * Scrollable container with a custom-styled scrollbar consistent across platforms.
 *
 * @status recommended
 * @group layout
 * @useWhen Providing a scrollable area with a consistent custom scrollbar appearance
 * @see https://quasar.dev/vue-components/scroll-area Quasar q-scroll-area API
 */
defineOptions({ name: 'HrScrollArea' });
</script>

<template>
  <q-scroll-area v-bind="$attrs">
    <!-- @slot Scrollable content. -->
    <slot />
  </q-scroll-area>
</template>
